import { Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { iDataNivel } from "../../../../interfaces/SuperAdmin/Pages/iDataNivel";
import { useNiveles } from "../../../../context/SuperAdmin/OASContexts/NivelesContext";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";

interface Props {
  nivel: iDataNivel;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const NivelesRow: React.FC<Props> = ({
  nivel,
  i,
  isSelected,
  handleSelect,
}) => {
  const { nombre, created_at } = nivel;
  const { handleEditNivel } = useNiveles();
  const navigate = useNavigate();

  const handleNavigate = (idNivel: string) => {
    navigate(`${idNivel}`);
  };

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(nivel.id_nivel)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center", maxWidth: 400 }}>
        {nombre}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {formatFechaWithHour(created_at)}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleEditNivel(nivel)}
        >
          <Tooltip title="Editar nivel">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleNavigate(nivel.id_nivel)}
        >
          <Tooltip title="Ver nivel">
            <IconButton aria-label="nivel" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
